import { z } from 'zod';

const qualificationSchema = z.object({
  category: z.string(),
  label: z.string(),
  skills: z.array(z.string()),
});

export const partnerWorkerProfileSchema = z.object({
  id: z.string(),
  email: z.string(),
  firstName: z.string(),
  infix: z.string().optional(),
  lastName: z.string(),
  phone: z.string(),
  workedShifts: z.number(),
  rating: z.number().optional(),
  attendanceRate: z.number().optional(),
  imageUrl: z.string().optional(),
  bio: z.string().optional(),
  city: z.string().optional(),
  qualifications: z.array(qualificationSchema),
  employmentType: z.string(),
  contractHours: z.number().nullish(),
});

export type PartnerWorkerProfile = z.infer<typeof partnerWorkerProfileSchema>;
